export default __webpack_public_path__ + "static/media/attachments-icon.1005ddb1.svg";